import { IAuthToken } from '@interticket/core';

export const AUTH_TOKEN: IAuthToken = {
  access_token: '46319b7b-becb-40d8-8c02-4608d54f3b22',
  refresh_token: 'e94abb21-7b0a-4a2e-a23c-2f4a6101d004',
  token_type: 'access',
  expires_in: 9999999,
  scope: 'api',
};
